exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dateclass[data-v-6c933b60]{background-color:#eee;border:2px solid gray;border-radius:3px;padding-left:5px;width:120px;margin-left:10px}.group[data-v-6c933b60]{display:flex;flex-flow:row wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-6c933b60","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/materieeldetail.vue
// module id = 32
// module chunks = 3